// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { spacing } from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'

const StarIconWrapper = styled.span`
  display: inline-block;
  ${({ fontSizeSp }) =>
    fontSizeSp &&
    css`
      font-size: ${fontSizeSp}px;
    `} ${mediaMin.phone`
      ${({ fontSizePc }) =>
        fontSizePc &&
        css`
          font-size: ${fontSizePc}px;
        `}
    `};
`
const StarIcon = styled.i`
  display: inline-block;
  color: ${Colors.grayD};
  font-size: inherit;
  ${({ score, mine }) =>
    score >= mine &&
    css`
      color: ${Colors.blue};
    `};
`
const StarHarfIcon = styled.span`
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    color: ${Colors.blue};
    width: 50%;
    font-size: 28px;
    overflow: hidden;
  }
`
const Star = styled.a`
  display: inline-block;
  ${props =>
    props.clickable &&
    `
    cursor: pointer;
  `} &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
    ${({ margin }) =>
      margin &&
      css`
        margin-left: ${margin}px;
      `};
  }
`

type PropTypes = {
  score: number,
  fontSizeSp: 28 | 24 | 16 | 10,
  margin: number,
  onChange?: Function,
}

type State = {
  localScore: ?number,
}

export default class ReputationStar extends React.Component<PropTypes, State> {
  constructor(props: PropTypes) {
    super(props)

    this.state = { localScore: null }
    this.mouseOver = this.mouseOver.bind(this)
    this.mouseLeave = this.mouseLeave.bind(this)
  }

  mouseOver: Function
  mouseOver(v: number) {
    if (this.props.touchable) {
      this.setState({ localScore: v })
    }
  }

  mouseLeave: Function
  mouseLeave(v: number) {
    if (this.props.touchable) {
      this.setState({ localScore: null })
    }
  }

  render() {
    const { score, margin, onChange, fontSizeSp } = this.props
    const { localScore } = this.state

    return (
      <StarIconWrapper fontSizeSp={fontSizeSp}>
        {[1, 2, 3, 4, 5].map(v => (
          <Star
            key={`reputation_star_${v}`}
            margin={margin}
            clickable={typeof onChange === 'function'}
          >
            <StarIcon
              className="fa fa-star"
              score={localScore || score}
              mine={v}
              onClick={() => typeof onChange === 'function' && onChange(v)}
              onMouseOver={() => this.mouseOver(v)}
              onMouseLeave={() => this.mouseLeave()}
            />
          </Star>
        ))}
      </StarIconWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReputationStar/index.jsx